module.exports = __webpack_public_path__ + "img/nerlynx-pack.c93a51c0.png";